import { callIntervalEntityName } from '../../../../backend/config/classifiers';
import { buildStorageValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
export function buildCallIntervalValueProvider() {
    return buildStorageValueProvider({
        entityName: callIntervalEntityName,
        label: 'Call Interval',
        classifierName: callIntervalEntityName,
        getValues: (client) => client
            .list({
            filter: [{ column: 'status', op: '=', value: 'active' }],
            orderBy: [{ column: 'value' }],
        })
            .then((result) => result.rows.map((row) => ({
            value: row.columns.value,
            label: row.columns.name,
        }))),
    });
}
